import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisVAlt, faTrashAlt } from "@fortawesome/pro-light-svg-icons";
import { Droppable } from "react-beautiful-dnd";
import { SliderPanel } from "../../../components";
import { trueFalseOptions } from "../../ReportsContainer/PeriodicCensus/columnMenu";
import ClickToSelectFunctionSlider from "./ClickToSelectFunctionSlider";
import { Census, CensusAndPayroll, Payroll } from "../../../utils";
import { get } from "lodash";
import { useContext } from "react";
import { manageMapperStore } from "../../../contexts";

export const UnmappedFieldOutput = (props) => {
  const {
    isOpen,
    fieldName,
    objName,
    isAdded,
    onDeleteClick,
    setClickToSelect,
    setFieldArrayName,
    forFunction = false,
    headerError,
    valueError,
    openSlider,
    setOpenSlider,
    index,
  } = props;
  const field = fieldName == "" ? `${objName}.value` : `${fieldName}.value`;
  const onCancel = () => {
    setOpenSlider(true);
  };

  return (
    <Droppable droppableId={field ?? "target fields"}>
      {(provided, snapshot) => (
        <div
          className={!forFunction ? "mt-3" : ""}
          {...provided.droppableProps}
          ref={provided.innerRef}
        >
          <div
            className={!forFunction ? "mb-2" : ""}
            style={{ display: "flex" }}
          >
            <div
              className="m-0 mr-2"
              style={{ fontSize: "12px", fontWeight: "500" }}
            ></div>
          </div>
          <div
            style={{
              width: forFunction ? "15rem" : "16.25rem",
              height: forFunction ? "3.5rem" : "2.875rem",
              borderStyle: "dotted",
              borderWidth: "thin",
              display: "inline-flex",
              alignItems: "center",
              color: "gray",
              backgroundColor: "#FFFFFF",
            }}
            className={forFunction ? "cornered-border p-2" : "rounded p-2"}
          >
            <div className="drop-icons">
              <FontAwesomeIcon
                icon={faEllipsisVAlt}
                size="1x"
                color="#BDBDBD"
              />
              <FontAwesomeIcon
                icon={faEllipsisVAlt}
                size="1x"
                color="#BDBDBD"
              />
            </div>
            <p style={{ fontSize: "10px", display: "flex", margin: "5px" }}>
              Drop here or
              <div
                onClick={() => {
                  setOpenSlider(!openSlider);
                }}
                style={{ textDecoration: "none", cursor: "pointer" }}
                to="/home"
              >
                <span style={{ color: "#2F80ED", margin: "2px" }}>
                  {" "}
                  {" " + "Click to select"}
                </span>
              </div>
              {/* <SliderPanel
                isOpen={openSlider}
                showCancelButton={false}
                showSave={false}
                showCancel={true}
                onClose={() => {}}
                size={30}
              >
                <ClickToSelectFunctionSlider
                  objName={objName}
                  openSlider = {openSlider}
                  setOpenSlider={setOpenSlider}
                  fieldName={fieldName}
                  index={index}
                />
              </SliderPanel> */}
            </p>
            {isAdded && (
              <FontAwesomeIcon
                color="#F16973"
                className="ft-16 mr-1 cursor-pointer"
                style={{ marginLeft: "2.1rem" }}
                icon={faTrashAlt}
                onClick={() => onDeleteClick()}
              />
            )}
          </div>
          {(headerError || valueError) && !isAdded && (
            <div className="ft-12 error-text" style={{ lineHeight: "1rem" }}>
              Required
            </div>
          )}
        </div>
      )}
    </Droppable>
  );
};
